import PropTypes from 'prop-types';
import React from 'react';
import qs from 'qs';
import config from '../../../config';

const ShopMap = ({ name, address }) => {
  const embed = 'https://www.google.com/maps/embed/v1/place?';
  const query = {
    q: `${name},${address}`,
    key: config.googleMapsKey,
    zoom: 11,
  };

  return (
    <iframe
      className="c-map"
      title="map"
      frameBorder="0"
      src={embed + qs.stringify(query)}
      allowFullScreen
    />
  );
};
ShopMap.propTypes = {
  name: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
};

export default ShopMap;



// WEBPACK FOOTER //
// ./src/app/reservation/components/ShopMap.jsx